<section class="sec">
    <div class="close" (click)="closeDialog()">
        <mat-icon style="cursor:pointer">close</mat-icon>
    </div>
    <div class="crt">Create Customer</div>
    <form [formGroup]="creatCustomer" class="createcustomer">
        <div class="form-group">
            <label class="crt1">Name</label>
            <input type="text" class="form-control" formControlName="name" autofocus="false" placeholder="Enter Name" (keydown)="Space($event)">
            <div *ngIf=" 
      Submitted  && f['name'].invalid
       " class="danger">
                <div class="error" style="color: red" *ngIf="f['name'].errors && f['name'].errors['required']">
                    *Mandatory Field
                </div>
            </div>
            <div *ngIf="f['name'].dirty && f['name'].invalid">
                <div class="error" style="color: red" *ngIf="
 f['name'].errors &&
 f['name'].errors['pattern']">
                    Enter valid name
                </div>
            </div>
            <div *ngIf="f['name'].dirty && f['name'].invalid">
              <div class="error" style="color: red" *ngIf="f['name'].errors && f['name'].errors?.maxlength">
                  Name cannot be longer than 150 characters
              </div>
          </div>
        </div>
        <div class="form-group">
            <label class="crt1">Email</label>
            <input type="text" class="form-control" formControlName="email" autofocus="false" placeholder="Enter Email" (keydown)="Space($event)">
            <div *ngIf=" 
      Submitted  && f['email'].invalid
       " class="danger">
                <div class="error" style="color: red" *ngIf="f['email'].errors && f['email'].errors['required']">
                    *Mandatory Field
                </div>
            </div>
            <div *ngIf="f['email'].dirty && f['email'].invalid">
                <div class="error" style="color: red" *ngIf="
   f['email'].errors &&
   f['email'].errors['pattern']
 ">
                    Enter valid email
                </div>

            </div>
        </div>
        <div class="form-group">
            <label class="crt1">Phone No</label>
            <input type="number" class="form-control" placeholder="Phone No" formControlName="phoneNo" onKeyPress="if(this.value.length==10) return false;" onkeydown=" return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
            />
            <div *ngIf=" 
      Submitted  && f['phoneNo'].invalid
       " class="danger">
                <div class="error" style="color: red" *ngIf="f['phoneNo'].errors && f['phoneNo'].errors?.required">
                    *Mandatory Field
                </div>
            </div>

            <div *ngIf="f['phoneNo'].dirty && f['phoneNo'].invalid">
                <div class="error" style="color: red" *ngIf="
 f['phoneNo'].errors &&
 f['phoneNo'].errors?.pattern
">
                    Enter valid phone no
                </div>

            </div>
        </div>
        <div class="submit">
            <button type="button" (click)="createcustomer(creatCustomer.valid)" class="btn__primary">Submit</button>
        </div>
    </form>
    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white">Please Wait. </p>
    </ngx-spinner>
</section>